import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideZonelessChangeDetection,
} from '@angular/core'
import { provideRouter, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router'
import { routes } from './app.routes'
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withNoIncrementalHydration,
} from '@angular/platform-browser'
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withFetch,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http'
import { LoadingInterceptor } from '@shared/services/loading.interceptor'
import { RetryInterceptor } from '@shared/services/retry.interceptor'
import { ApiInterceptor } from '@shared/services/api.interceptor'
import { environment } from '@environments/environment'
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { provideTranslateService } from '@ngx-translate/core'
import { NgxGfmoneySupportModule } from '@yuri.karkhachev/ngx-gfmoney-support'
import { NgxGfmoneyLibModule } from '@yuri.karkhachev/ngx-gfmoney-lib'
import { provideEnvironmentNgxMask } from 'ngx-mask'
import localeFi from '@angular/common/locales/fi'
import { ErrorHandlerService } from '@shared/services/error-handler.service'
import { errorLogInterceptor } from '@shared/services/error-log.interceptor'
registerLocaleData(localeFi, 'fi')
import { provideServiceWorker } from '@angular/service-worker'

export const CHUNK_LOAD_ERROR_RELOAD = 'chunk-load-error-reload'

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      NgxGfmoneyLibModule.forRoot({ servicesUrl: environment.servicesApiHost }),
      NgxGfmoneySupportModule.forRoot({
        allowedFileTypes: 'image/jpeg,image/png,.pdf,.txt',
        apiUrl: '',
        brand: environment.companyName,
        dateFormat: 'yyyy-MM-dd HH:mm',
        homePagePath: '/dashboard',
      }),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fi' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: '€' },
    DatePipe,
    CurrencyPipe,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideEnvironmentNgxMask(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'fi',
      lang: 'fi',
    }),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withNavigationErrorHandler(navigationError => {
        const error = navigationError.error
        const errorHandler = inject(ErrorHandler)
        errorHandler.handleError(error)
      }),
    ),
    provideClientHydration(
      withEventReplay(),
      withHttpTransferCacheOptions({
        includePostRequests: false,
      }),
      withNoIncrementalHydration(),
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi(), withInterceptors([errorLogInterceptor])),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}
